import { render } from "./TcPrivacy.vue?vue&type=template&id=66885e7e&scoped=true"
import script from "./TcPrivacy.vue?vue&type=script&lang=js"
export * from "./TcPrivacy.vue?vue&type=script&lang=js"

import "./TcPrivacy.vue?vue&type=style&index=0&id=66885e7e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66885e7e"]])

export default __exports__